var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}

export { getDefaultOptions };
